<template>
  <v-app>
    <v-main>
      <div class="custom-toast-container">
        <Toast
          v-for="item in $store.state.toasts"
          :key="item.id"
          v-bind="item"
        />
      </div>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Toast from '@/components/_shared/Toast'

export default {
  name: 'App',

  components: { Toast },
}
</script>

<style lang="scss">
html,
body {
  scroll-behavior: smooth;
  margin: 0px !important;
  padding: 0px !important;
}

p {
  margin: 0px !important;
}

.custom-toast-container {
  // Should be above all content on the DOM
  z-index: 202;
  position: fixed;
  top: 10px;
  right: 10px;
}

.theme--light.v-application {
  background-color: var(--v-secondary-base) !important;
}

// Hide input type number spinners
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
